import React, { Component } from "react";
import withStyles from "@mui/styles/withStyles";
import PropTypes from "prop-types";
import classNames from "classnames";
import DragIndicator from "@mui/icons-material/DragIndicator";
import Draggable from "react-draggable";

const styles = {
  root: {
    position: "absolute",
    left: 0,
    top: 20,
    width: 280,
    border: "2px solid rgb(85, 85, 85)",
    opacity: 0.8,
    textAlign: "left",
    userSelect: "none",
    background: "rgba(255, 255, 255, 0.95)",
    padding: 8,
  },
  dragIndicator: {
    color: "#000",
    position: "absolute",
    top: 5,
    right: 5,
    cursor: "grab",
  },
  grabbing: {
    cursor: "grabbing",
  },
  debugDataKey: {
    width: 150,
    display: "inline-block",
  },
  debugDataValue: {
    display: "inline-block",
  },
};

/**
 * class to render minimap and handle interaction
 */
class ScanDebugData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      grabbing: false,
    };
    this.minimapRef = React.createRef();
    this.x = 0;
    this.y = 0;
  }

  /**
   * Change position of minimap canvas
   * @param {AcitonEvent} e Mouse event
   * @param {Object} ui object with x,y coordinate of mouse location
   */
  handleDrag = (e, ui) => {
    this.x = ui.x;
    this.y = ui.y;
  };

  // handle dragging of the minimap region rectangle
  mouseDown = (event) => {
    this.onMinimapClick(event);
    this.dragging = true;
    event.preventDefault();
  };

  // handle dragging of the minimap region rectangle
  mouseMove = (event) => {
    if (this.dragging == true) {
      this.onMinimapClick(event);
    }
    event.preventDefault();
  };

  mouseUp = (event) => {
    this.dragging = false;
    event.preventDefault();
  };

  render() {
    const { grabbing } = this.state;
    const { classes, debugDataList } = this.props;
    const mapVisible = true;
    return (
      <Draggable
        handle=".handle"
        defaultPosition={{ x: 5, y: -15 }}
        onStart={() => this.setState({ grabbing: true })}
        onDrag={this.handleDrag}
        onStop={() => this.setState({ grabbing: false })}
      >
        <div
          style={{
            visibility: mapVisible ? "visible" : "hidden",
            pointerEvents: "all",
          }}
          ref={this.minimapRef}
          className={classes.root}
        >
          <div
            onMouseDown={this.mouseDown}
            onMouseMove={this.mouseMove}
            onMouseUp={this.mouseUp}
          >
            {debugDataList.map((data, index) => (
              <div key={index}>
                <div className={classes.debugDataKey}>{data.name}:</div>
                <div className={classes.debugDataValue}>{data.value}</div>
              </div>
            ))}
          </div>

          <DragIndicator
            className={classNames(
              "handle",
              classes.dragIndicator,
              grabbing && classes.grabbing
            )}
          />
        </div>
      </Draggable>
    );
  }
}

ScanDebugData.propTypes = {
  classes: PropTypes.object.isRequired,
  scanViewerContext: PropTypes.object,
  src: PropTypes.string,
  debugDataList: PropTypes.array,
};

export default withStyles(styles)(ScanDebugData);
